import { Attachment } from "../../../types/attachments/Attachment";
import { DECREMENT_UPLOAD_COUNT, UPLOAD_AGGREGATE_FILE } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface UploadAggregateFileState extends BaseAsyncReducerState {
  path: string,
  fileSize: number,
  fileName: string,
  uploaded: boolean,
  activeUploads: number,
  attachments?: Attachment[],
  result?: Record<string, string>[]
}

const initialState: UploadAggregateFileState = {
  loading: false,
  error: false,
  success: false,
  uploaded: false,
  path: "",
  fileSize: 0,
  activeUploads: 0,
  fileName: "",
  message: "",
  attachments: []
}

function getUploadAggregateFileReducer(state = initialState, action: AppAction) {
  const { payload } = action;
  switch (action.type) {
    case UPLOAD_AGGREGATE_FILE.PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        activeUploads: state.activeUploads += 1
      }
    case UPLOAD_AGGREGATE_FILE.SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false,
        error: false,
        success: true,
        activeUploads: state.activeUploads -= 1
      }
    case UPLOAD_AGGREGATE_FILE.ERROR:
      return {
        ...state,
        ...payload,
        loading: false,
        error: true,
        success: false,
        activeUploads: state.activeUploads -= 1
      }
    case UPLOAD_AGGREGATE_FILE:
      return initialState
    case DECREMENT_UPLOAD_COUNT:
      return {
        ...state,
        activeUploads: Math.max(0, state.activeUploads - 1),
      };
    default:
      return state
  }
}

export default getUploadAggregateFileReducer;